import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import './PromoCodeModal.css';

interface PromoCodeModalProps {
  promoCode: string;
  onClose: () => void;
  onApply: () => void;
}

export const PromoCodeModal: React.FC<PromoCodeModalProps> = ({ 
  promoCode, 
  onClose,
  onApply 
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(promoCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy promo code:', err);
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = promoCode;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (e) {
        console.error('Fallback copy failed:', e);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div className="promo-modal-overlay" onClick={onClose}>
      <div className="promo-modal" onClick={(e) => e.stopPropagation()}>
        <button className="promo-modal-close" onClick={onClose} aria-label="Close">
          <Icon name="close" size={24} />
        </button>

        <div className="promo-modal-content">
          <div className="promo-icon">🎁</div>
          
          <h2 className="promo-title">
            {t('promo.modal.title', 'Ваш промокод на 30 дней!')}
          </h2>

          <div className="promo-code-box">
            <div className="promo-code-text">{promoCode}</div>
            <button 
              className={`promo-copy-btn ${copied ? 'copied' : ''}`}
              onClick={handleCopy}
              aria-label={copied ? 'Copied' : 'Copy'}
            >
              <Icon name={copied ? 'check' : 'copy'} size={20} />
            </button>
          </div>

          <button className="promo-copy-button" onClick={handleCopy}>
            {copied 
              ? t('promo.modal.copied', '✓ Скопировано!') 
              : t('promo.modal.copy', 'Скопировать промокод')}
          </button>

          <div className="promo-instructions">
            <h3>{t('promo.modal.howto', 'Как активировать:')}</h3>
            <ol>
              <li>{t('promo.modal.step1', 'Откройте раздел "Подписка"')}</li>
              <li>{t('promo.modal.step2', 'Нажмите "Ввести промокод"')}</li>
              <li>{t('promo.modal.step3', 'Вставьте скопированный код')}</li>
            </ol>
          </div>

          <button className="promo-apply-button" onClick={onApply}>
            {t('promo.modal.activate', 'Активировать сейчас')}
          </button>

          <p className="promo-note">
            {t('promo.modal.note', '* Промокод можно использовать только один раз')}
          </p>
        </div>
      </div>
    </div>
  );
};

